import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetMerchantMonthlyTransactionAmountRequest = {
    page?: number;
    size?: number;
    year: number;
    currency: string;
    merchantName?: string
};

export type GetMerchantMonthlyTransactionAmountResponse = BasePagingResponse<Array<any>>;

async function GetMerchantMonthlyTransactionAmount(
    data: GetMerchantMonthlyTransactionAmountRequest
): Promise<any> {
    try {
        return (await axiosInstance.post("/Reconciliation/GetMerchantMonthlyTransactionAmount", data)).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetMerchantMonthlyTransactionAmount() {
    return useMutation<GetMerchantMonthlyTransactionAmountResponse, Error, GetMerchantMonthlyTransactionAmountRequest>((variables) =>
        GetMerchantMonthlyTransactionAmount(variables)
    );
}

